import { z } from 'zod';
import { emailSchema } from './auth';

export const subscribeSchema = z.object({
  email: emailSchema,
});
export type SubscribeInput = z.infer<typeof subscribeSchema>;
